(() => {
  const mount = document.getElementById('gastro-ggm-together');
  if (!mount) return;
  const fi = document.documentElement.lang.startsWith('fi');
  const update = () => {
    const widget = mount.querySelector('.cbb-frequently-bought-container');
    if (!widget) return;
    const products = widget.querySelector('.cbb-frequently-bought-products');
    const companion = products?.querySelectorAll(':scope > .cbb-frequently-bought-product:not(.cbb-frequently-bought-product-form-tile)')[1];
    const details = companion?.querySelector('.cbb-frequently-bought-product-compact-wrapper > li');
    const total = widget.querySelector('.cbb-frequently-bought-total-price-box');
    const button = widget.querySelector('.cbb-frequently-bought-add-button');
    if (!details || !total || !button) return;
    const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
    setText(widget.querySelector('.cbb-frequently-bought-title'), fi ? 'Suositellaan yhdessä' : 'Recommended together');
    setText(button.querySelector('.translatable'), fi ? 'Lisää ostoskoriin' : 'Add to cart');
    setText(total.querySelector('.cbb-frequently-bought-total-price-text'), fi ? 'Pakettihinta' : 'Bundle price');
    button.setAttribute('aria-label', fi ? 'Lisää päätuote ja suositeltu tarvike ostoskoriin' : 'Add this product and its recommended accessory to cart');
    if (total.parentElement !== details) details.append(total);
    if (!companion.querySelector('.gastro-fbt-discount')) {
      const badge = document.createElement('span');
      badge.className = 'gastro-fbt-discount'; badge.textContent = '−5%'; companion.append(badge);
    }
    widget.classList.add('gastro-fbt-ready');
  };
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; update(); });
  }).observe(mount, { childList: true, subtree: true, characterData: true });
  update();
})();

